/* Developer: Nithin | Date: 06-07-2026 | Changes: Commented out old OrderingScreen routing and updated to LeadOrderingWorkspace for workflow screen */
import React from 'react';
import { createPortal } from 'react-dom';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import ScrollToTop from './components/ui/ScrollToTop';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/authStore';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './pages/verve-login/screens/LoginPage';
import { DashboardPage } from './pages/verve-dashboard/screens/DashboardPage';
import { HRDashboard, EmployeeOnboardingScreen, AttendanceScreen, LeavesScreen, PaySetupScreen, PayslipsScreen } from './pages/hr';
import { HRProvider } from './pages/hr/context/HRContext';
import { HomePage } from './pages/verve-home/screens/HomePage';
import ContactScreen from './pages/verve-contacts/screens/contactScreen';
import LeadsScreen from './pages/verve-leads/leads/screens/LeadsScreen';
import ApprovalsScreen from './pages/verve-approvals/screens/ApprovalsScreen';
import { StockScreen } from './pages/verve-inventory/screens/StockScreen';


// static component
// import { DesignPage } from './pages/DesignPage';
// correct one
import { ProjectsScreen } from './pages/verve-projects-flow-final/screens/ProjectsScreen';
// static component
// import { ProjectsPage } from './pages/ProjectsPage';
// import { InventoryScreen } from './pages/verve-inventory/screens/InventoryScreen';
import { InventoryPage } from './pages/inventory/pages/InventoryPage';
// correct one
import AccountsScreen from './pages/verve-accounts/screens/AccountsScreen';
// static component
// import { AccountsPage } from './pages/AccountsPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { UsersPage } from './pages/UsersPage';
import { SettingsPage } from './pages/SettingsPage';
import { NotificationsPage } from './pages/NotificationsPage';
import DocumentsScreen from './pages/verve-documents/screens/DocumentsScreen';
import { AttendanceTrackerPage } from './pages/attendance/pages/AttendanceTrackerPage';
import ExcelEditorScreen from './pages/verve-documents/screens/ExcelEditorScreen';
import WordEditorScreen from './pages/verve-documents/screens/WordEditorScreen';
import { DesignSystemPage } from './pages/DesignSystemPage';
import { ProjectDetailsScreen } from './pages/verve-projects-flow-final/screens/ProjectDetailsScreen';
import AutoCADScreen from './pages/verve-autocad/screens/AutoCADScreen';
import WhatsAppDashboard from './pages/whatsapp/screen/WhatsAppDashboard';
import CampaignDashboard from './pages/whatsapp/campaigns/CampaignDashboard';
import CreateCampaign from './pages/whatsapp/campaigns/CreateCampaign';
import { SocialMediaDashboard } from './pages/Verve-social-media/pages/SocialMediaDashboard';
import { BudgetScreen } from './pages/budget/screen/BudgetScreen';
import OrderingScreen from './pages/ordering/screen/OrderingScreen';
import { LeadOrderingWorkspace } from './pages/ordering/screen/LeadOrderingWorkspace';
import { CatlogScreen } from './pages/catlog/screens/CatlogScreen';
import { LeadExecutionsScreen } from './pages/lead_executions/screens/LeadExecutionsScreen';
import { LeadExecutionsDetails } from './pages/lead_executions/screens/lead_executions_details';
import TechnicalSupportScreen from './pages/support/screens/TechnicalSupportScreen';
import CustomerSupportScreen from './pages/support/screens/CustomerSupportScreen';
import './styles/index.css';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/home" replace />;
  }

  return <Layout>{children}</Layout>;
};

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <BrowserRouter>
      <ScrollToTop />
      {/*
        Toaster is portaled to document.body so it renders at the same DOM level as Modal
        (which also portals to document.body). Without this, toasts appeared behind modals
        because the Toaster was inside the React tree while Modal portals bypass it entirely,
        breaking z-index stacking contexts. containerStyle.zIndex: 9999 ensures toasts
        layer above the Modal's z-[100].
      */}
      {createPortal(
        <Toaster
          position="top-right"
          containerStyle={{ zIndex: 9999 }}
          toastOptions={{
            duration: 3000,
            style: { fontFamily: "'DM Sans', sans-serif", fontSize: '14px', borderRadius: '10px', border: '1px solid #F0F0F0', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' },
            success: { iconTheme: { primary: '#10B981', secondary: 'white' } },
            error: { iconTheme: { primary: '#EF4444', secondary: 'white' } },
          }}
        />,
        document.body
      )}
      <Routes>
        <Route path="/home" element={<HomePage />} />
        <Route path="/contacts" element={<ProtectedRoute><ContactScreen /></ProtectedRoute>} />
        <Route path="/login" element={isAuthenticated ? <Navigate to="/home" replace /> : <LoginPage />} />
        <Route path="/" element={<ProtectedRoute allowedRoles={['admin', 'owner', 'installation_team']}><DashboardPage /></ProtectedRoute>} />
        <Route path="/leads" element={<ProtectedRoute><LeadsScreen /></ProtectedRoute>} />
        <Route path="/approvals" element={<ProtectedRoute allowedRoles={['admin', 'owner']}><ApprovalsScreen /></ProtectedRoute>} />

        <Route path="/design-system" element={<ProtectedRoute><DesignSystemPage /></ProtectedRoute>} />
        {/* static component */}
        {/* <Route path="/projects-static" element={<ProtectedRoute><ProjectsPage /></ProtectedRoute>} /> */}
        {/* correct one */}
        <Route path="/projects" element={<ProtectedRoute><ProjectsScreen /></ProtectedRoute>} />
        <Route path="/projects/:id" element={<ProtectedRoute><ProjectDetailsScreen /></ProtectedRoute>} />
        {/* <Route path="/inventory" element={<ProtectedRoute><InventoryScreen /></ProtectedRoute>} /> */}
        <Route path="/inventory" element={<ProtectedRoute><InventoryPage /></ProtectedRoute>} />
        {/* static component */}
        {/* <Route path="/accounts-static" element={<ProtectedRoute><AccountsPage /></ProtectedRoute>} /> */}
        {/* correct one */}
        <Route path="/accounts" element={<ProtectedRoute><AccountsScreen /></ProtectedRoute>} />
        <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
        <Route path="/documents" element={<ProtectedRoute><DocumentsScreen /></ProtectedRoute>} />
        <Route path="/attendance-tracker" element={<ProtectedRoute><AttendanceTrackerPage /></ProtectedRoute>} />
        <Route path="/documents/edit/:id" element={<ProtectedRoute><ExcelEditorScreen /></ProtectedRoute>} />
        <Route path="/documents/edit-word/:id" element={<ProtectedRoute><WordEditorScreen /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
        <Route path="/autocad" element={<ProtectedRoute><AutoCADScreen /></ProtectedRoute>} />
        <Route path="/whatsapp" element={<ProtectedRoute><WhatsAppDashboard /></ProtectedRoute>} />
        <Route path="/whatsapp-campaigns" element={<ProtectedRoute><CampaignDashboard /></ProtectedRoute>} />
        <Route path="/whatsapp-campaigns/create" element={<ProtectedRoute><CreateCampaign /></ProtectedRoute>} />
        <Route path="/budget" element={<ProtectedRoute><BudgetScreen /></ProtectedRoute>} />
        <Route path="/lead-executions" element={<ProtectedRoute><LeadExecutionsScreen /></ProtectedRoute>} />
        <Route path="/lead-executions/:id" element={<ProtectedRoute><LeadExecutionsDetails /></ProtectedRoute>} />
        {/* Developer: Nithin | Date: 06-07-2026 | Changes: Commented out old OrderingScreen routing and updated to LeadOrderingWorkspace for workflow screen; added /ordering/create for quote creation */}
        {/* <Route path="/ordering" element={<ProtectedRoute><OrderingScreen /></ProtectedRoute>} /> */}
        <Route path="/ordering/create" element={<ProtectedRoute><OrderingScreen /></ProtectedRoute>} />
        <Route path="/ordering" element={<ProtectedRoute><LeadOrderingWorkspace /></ProtectedRoute>} />
        <Route path="/ordering/:id" element={<ProtectedRoute><LeadOrderingWorkspace /></ProtectedRoute>} />
        <Route path="/catalog" element={<ProtectedRoute><CatlogScreen /></ProtectedRoute>} />
        <Route path="/social-media" element={<ProtectedRoute><SocialMediaDashboard /></ProtectedRoute>} />

        {/* New route for StockScreen */}
        <Route path="/stock" element={<ProtectedRoute><StockScreen /></ProtectedRoute>} />
        
        {/* Support Routes */}
        <Route path="/technical-support" element={<ProtectedRoute><TechnicalSupportScreen /></ProtectedRoute>} />
        <Route path="/customer-support" element={<ProtectedRoute><CustomerSupportScreen /></ProtectedRoute>} />

        {/* HR Routes */}
        <Route path="/hr/*" element={
          <HRProvider>
            <ProtectedRoute allowedRoles={['owner', 'hr', 'accountant']}>
              <Routes>
                <Route path="dashboard" element={<HRDashboard />} />
                <Route path="onboarding" element={<EmployeeOnboardingScreen />} />
                <Route path="attendance" element={<AttendanceScreen />} />
                <Route path="leaves" element={<LeavesScreen />} />
                <Route path="pay-setup" element={<PaySetupScreen />} />
                <Route path="payslips" element={<PayslipsScreen />} />
              </Routes>
            </ProtectedRoute>
          </HRProvider>
        } />
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
